import { trackEvent } from '../util/analytics'

up.compiler('.flashes--flash.alert', (element: HTMLElement) => {
  if (element.closest('.layoutless')) {
    // Alerts should not be interactable on "layoutless" pages
    return
  }

  function remove(): void {
    up.animate(element, 'move-to-right').then(() => {
      element.parentNode!.removeChild(element)
    })
  }

  function typeFromClass(): string | undefined {
    for (const className of element.classList) {
      if (className.startsWith('alert-')) {
        return className.replace('alert-', '')
      }
    }
  }

  trackEvent('flash.show', { text: element.textContent, type: typeFromClass() })

  const closeButton = up.element.createFromHTML(
    '<button type="button" class="btn-close" aria-label="Hinweis schließen"></button>',
  )
  element.classList.add('alert-dismissible')
  element.setAttribute('aria-live', 'assertive')
  element.append(closeButton)
  closeButton.addEventListener('click', remove)

  return remove
})
